export enum ToolbarAction {
    NONE = "none-select",
    POINT = "point-select",
    RECT = "rect-select",
    COPY = "copy-select",
    POLYLINE = "polyline-select",
    POLYGON = "polygon-select",
    ADD_REMOVE_POINTS = "pointer-add-remove-points-on-polygons",
    DELETE_ALL = "delete-all-select",
    SELECTION_LOCK = "selection-lock",
    BACKGROUND_TOGGLE = "background-toggle",
    ZOOM_IN = "zoom-in",
    ZOOM_OUT = "zoom-out",
    ZOOM_DRAG = "zoom-drag",
}